import React, { useRef, useState } from "react";
import { Button, message } from "antd";
import { createFacilityReport } from "@/redux/api";
import { usePdfContext } from "@containers/PdfReport/context";

const ReportPreview = () => {
  const iframeRef = useRef(null);
  const [saveLoading, setSaveLoading] = useState(false);
  const { previewUrl, pdfFormValue, reloadTable, goToLoadingStep, closeDrawer } = usePdfContext();

  const onDownload = () => {
    if (!previewUrl) return;
    const a = document.createElement("a");
    a.href = previewUrl;
    a.download = `${pdfFormValue.name}.pdf`;
    a.click();
  };

  const onSave = async () => {
    setSaveLoading(true);
    try {
      await createFacilityReport(pdfFormValue);
      message.success("Saved");
      closeDrawer();
      reloadTable();
    } catch (error) {
      message.error("Save failed");
    } finally {
      setSaveLoading(false);
    }
  };

  return (
    <>
      <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
        <Button onClick={goToLoadingStep}>Back</Button>
        <Button onClick={onDownload}>Download</Button>
        <Button type="primary" loading={saveLoading} onClick={onSave}>
          Save
        </Button>
      </div>
      <iframe ref={iframeRef} title="facility-report-pdf" width="100%" height={1000} src={previewUrl}></iframe>
    </>
  );
};

export default ReportPreview;
